// There is a CommonJS version of this service in src/domain/services/configService.js
// Keep both versions in sync.
export const conf = {};

// Empty object before setting its values.
export const setConfig = rawConfigString => {
  Object.keys(conf).forEach(key => delete conf[key]);
  Object.assign(conf, JSON.parse(rawConfigString));
  conf.isPreview = process.env.IS_PREVIEW;
};

export const t = key => conf.locale[key] || key;
